import React, { Component } from 'react'
import { Table, Modal, Form, Input, Select, Button, Spin } from 'antd'
import { api, app } from '../../app'
import utils from '../../utils'
import PropTypes from 'prop-types'

const Option = Select.Option
const FormItem = Form.Item

class LeaveTeam extends Component {

    constructor (props) {
        super(props)
        this.state = {
            data_loading: true,
            restoreInfo: {},
            playerList: [],
            team_loading: false,
            all_team: []
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.dataSource()
        await this.teamData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    componentWillReceiveProps (props) {
        this.dataSource(props.teamno)
    }

    /**
     * 队伍列表
     **/
    teamData = async () => {
        await this.setData({ team_loading: true })
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.TeamListAll, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
            data = []
        }
        await this.setData({ team_loading: false, all_team: data })
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据
     * @param teamno
     */
    dataSource = async (teamno) => {
        await this.setData({ data_loading: true })
        if (!teamno) teamno = this.props.teamno
        const params = {
            teamno,
            type: 4,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.LeaveUserList, params)
        if (flag !== 1) {
            app.alert(msg, 'error')
        }
        await this.setData({ playerList: utils.addArrayKey(data || []), data_loading: false })
    }

    /**
     * 恢复
     * @param info
     */
    handleRecovery = (restoreInfo) => {
        this.setData({ restoreInfo, restore_visible: true })
    }

    /**
     * 提交恢复信息
     * @param e
     * @returns {Promise<void>}
     */
    handleSubmitRecovery = (e) => {
        if (!this.state.restore_loading) {
            e.preventDefault()
            this.props.form.validateFields(async (err, values) => {
                if (!err) {
                    await this.setData({ restore_loading: true })
                    values.indexno = app.getData('indexno')
                    values.account = app.getData('account')
                    const { flag, msg } = await app.post(api.LeaveRestore, values)
                    if (flag === 1) {
                        app.alert('提交成功', 'success')
                        this.handleCloseModal()
                        await this.dataSource()
                    } else {
                        app.alert(msg, 'error')
                    }
                    await this.setData({ restore_loading: false })
                }
            })
        }
    }

    /**
     * 关闭弹框
     */
    handleCloseModal = () => {
        this.setData({ restoreInfo: {}, restore_visible: false, restore_loading: false })
    }

    /**
     * 转入
     */
    handleChangeInto = (item) => {
        let loading = false, team = null, reason = null
        const { all_team, team_loading } = this.state
        Modal.confirm({
            title: `【${item.vname}】转入信息`,
            content: (
                <div>
                    <div style={{ marginTop: 15 }}>转入队伍</div>
                    <div>
                        <Select placeholder="选择转入队伍" style={{ width: '100%' }} showSearch onChange={v => {
                            team = v
                        }} notFoundContent={team_loading ? (<Spin size="small"/>) : null} optionFilterProp="children">
                            {
                                all_team.map(at => {
                                    return (
                                        <Option value={at.teamno} key={at.teamno}>{at.teamname}</Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                    <div style={{ marginTop: 15 }}>转入原因</div>
                    <div>
                        <Input.TextArea placeholder="请填写转入原因" rows={4} onChange={e => {
                            reason = e.target.value
                        }}/>
                    </div>
                    <div style={{ color: 'red', marginTop: 15 }}>注：转入队伍会重新生成新的存心编号。</div>
                </div>
            ),
            width: 600,
            centered: true,
            confirmLoading: loading,
            onOk: async () => {
                if (loading) throw false
                if (!team) {
                    app.alert('请选择转入队伍', 'warn')
                    throw false
                }
                if (!reason) {
                    app.alert('请填写转入原因', 'warn')
                    throw false
                }
                loading = true
                let { flag, msg } = await app.post(api.JoinTeam, {
                    reason,
                    type: 1,
                    style: 1,
                    current_teamno: team,
                    indexno_object: item.indexno,
                    original_teamno: item.teamno,
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                })
                if (flag === 1) {
                    app.alert(msg, 'success')
                    this.dataSource()
                    return true
                } else {
                    app.alert(msg, 'error')
                    throw false
                }
            }
        })
    }

    render () {
        const columns = [
                {
                    title: '档案编号',
                    dataIndex: 'indexno',
                    key: 'indexno',
                    width: '15%',
                },
                {
                    title: '存心编号',
                    dataIndex: 'bsrno',
                    key: 'bsrno',
                    width: '15%',
                },
                {
                    title: '姓名',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '15%',
                },
                {
                    title: '性别',
                    dataIndex: 'sex',
                    key: 'sex',
                    width: '10%',
                },
                {
                    title: '入队时间',
                    dataIndex: 'indate',
                    key: 'indate',
                    width: '15%',
                    render (text) {
                        return (<span>{text || '无记录'}</span>)
                    }
                },
                {
                    title: '离队时间',
                    dataIndex: 'outdate',
                    key: 'outdate',
                    width: '15%',
                    render (text) {
                        return (<span>{text || '无记录'}</span>)
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'indexno',
                    key: 'cz',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <div style={{textAlign: 'right'}}>
                                <Button onClick={() => this.handleRecovery(record)} size="small" type="primary">恢复</Button>
                                {
                                    record.volunteer_state === '4' ? (
                                        <Button onClick={() => this.handleChangeInto(record)} size="small" type="primary"
                                                style={{ marginLeft: 10 }}>转入</Button>
                                    ) : null
                                }
                            </div>
                        )
                    }
                }
            ],
            { data_loading, playerList, restoreInfo, restore_visible, restore_loading } = this.state,
            { getFieldDecorator, getFieldValue } = this.props.form,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 17, offset: 1 },
            },
            identity = getFieldValue('identity')
        let reasonItem = null
        if (identity === '4' || identity === '5') {
            reasonItem = (
                <FormItem
                    {...formItemLayout}
                    label="身份修改原因"
                >{getFieldDecorator('leave_reason', {
                    rules: [{
                        required: true, message: '请输入离队/清退 原因！',
                    }]
                })(
                    <Input.TextArea placeholder="请填写离队/清退 原因" rows={4}/>
                )}
                </FormItem>
            )
        }
        return (
            <div style={{ height: '100%' }}>
                <Table className="ranks_table"
                       title={() => <div className="player-table-title">离队队员</div>}
                       locale={app.tbLocale(data_loading)}
                       columns={columns}
                       dataSource={playerList}
                       loading={data_loading}
                       pagination={false}
                       scroll={{ y: 'calc(100% - 53px)' }}
                       size="small"
                />
                <Modal visible={restore_visible}
                       title="恢复"
                       onCancel={this.handleCloseModal}
                       onOk={this.handleSubmitRecovery}
                       okText="确认"
                       cancelText="取消"
                       maskClosable={false}
                       confirmLoading={restore_loading}
                       className="edit-team-modal"
                       centered={true}
                >
                    <Form>
                        {getFieldDecorator('volunteer_id', { initialValue: restoreInfo.volunteer_id })(
                            <Input type="hidden"/>
                        )}
                        {getFieldDecorator('teamno', { initialValue: restoreInfo.teamno })(
                            <Input type="hidden"/>
                        )}
                        <FormItem
                            {...formItemLayout}
                            label="身份"
                        >{getFieldDecorator('identity', {
                            rules: [{
                                required: true, message: '请选择队员身份！',
                            }]
                        })(
                            <Select placeholder="请选择队员身份">
                                <Option value="1">队员</Option>
                                {/*<Option value="2">预备队员</Option>*/}
                                {/*<Option value="3">认证志愿者</Option>*/}
                                {/*<Option value="6">志愿者</Option>*/}
                                <Option value="5">清退</Option>
                            </Select>
                        )}
                        </FormItem>
                        {reasonItem}
                    </Form>
                </Modal>
            </div>
        )
    }
}

LeaveTeam.propTypes = {
    teamno: PropTypes.string.isRequired,
}

export default Form.create()(LeaveTeam)



// WEBPACK FOOTER //
// ./src/routes/ranks/LeaveTeam.jsx